import Skeleton from "@/components/shared/Skeleton";
import { PIPELINE_ACCENTS } from "../common";

const PipelineCard = ({ label, value, colorIdx, loading }) => {
  const { bgClass, borderClass, textClass } = PIPELINE_ACCENTS[colorIdx % PIPELINE_ACCENTS.length];

  return (
    <div className={`rounded-lg border min-w-0 ${borderClass} ${bgClass}`}>
      <div className="rounded-lg flex flex-col items-center justify-center px-2.5 py-2 min-h-[54px] min-w-0">
        {loading ? (
          <>
            <Skeleton className="h-4 w-8" />
            <Skeleton className="h-3 w-14 mt-1.5" />
          </>
        ) : (
          <>
            <span className={`text-[1.35rem] leading-none font-bold tracking-tight tabular-nums ${textClass}`}>{String(value ?? 0).padStart(2, "0")}</span>
            <span title={label} className={`block w-full mt-1 text-[10px] leading-none text-center truncate opacity-75 ${textClass}`}>{label}</span>
          </>
        )}
      </div>
    </div>
  );
};

export default PipelineCard;
